import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = null as string | null;

const slice = createSlice({
  name: '$menuSource',
  initialState,
  reducers: {
    setMenuSource(state, action: PayloadAction<string | null>) {
      return action.payload;
    },
  },
});

export const { setMenuSource } = slice.actions;
export default slice.reducer;
